import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { camerasKeys } from './cameras.keys';
import { addCamera, deleteCamera, getCameraStreamSettings, regenerateCameraStreamKey } from './cameras.api';
// Every camera mutation answers with the full settings
const setStreamSettings = (data) => {
    queryClient.setQueryData(camerasKeys.streamSettings(), data);
};
export const useCameraStreamSettingsQuery = () => {
    return useQuery({
        queryKey: camerasKeys.streamSettings(),
        queryFn: () => getCameraStreamSettings()
    });
};
export const useAddCameraMutation = () => {
    return useMutation({
        mutationFn: addCamera,
        onSuccess: setStreamSettings
    });
};
export const useRegenerateCameraStreamKeyMutation = () => {
    return useMutation({
        mutationFn: regenerateCameraStreamKey,
        onSuccess: setStreamSettings
    });
};
export const useDeleteCameraMutation = () => {
    return useMutation({
        mutationFn: deleteCamera,
        onSuccess: setStreamSettings
    });
};
//# sourceMappingURL=cameras.query.js.map